import React, { useEffect } from "react";
import data from "./reference.json";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import WrapperContainer from "./utilities/WrapperContainer";

export function ReferenceCard(props) {
  return (
    <>
      <div
        style={{ paddingLeft: "1.5rem", marginBottom: "20px" }}
        key={props.index}
      >
        <div className="d-flex justify-content-between">
          <div>
            <h6 className="sub-step-link">{props.item.title}</h6>
            <p className="custom-size" style={{ margin: "9px 0 0 0" }}>
              {props.item.authors} <em>{props.item.source}</em>{" "}
              {props.item.year}
            </p>
          </div>
          <a
            href={props.item.link}
            target="_blank"
            rel="noreferrer"
            style={{
              color: "#0061BB",
              textDecoration: "none",
              fontWeight: "600",
              alignContent: "center",
              marginLeft: "10px",
            }}
          >
            <OpenInNewIcon />
          </a>
        </div>
      </div>
      <hr style={{ margin: "24px 0" }} />
    </>
  );
}
export function ReferencesContent() {
  return (
    <>
      {/* Performance Section */}
      <p className="custom-title" style={{ marginBottom: "34px" }}>
        iSort&trade; Performance
      </p>
      <div>
        {data.performance.map((item, index) => (
          <ReferenceCard item={item} index={index} />
        ))}
      </div>

      <p className="custom-title" style={{ margin: "34px 0" }}>
        iSort&trade; Core Technologies
      </p>
      
      <h6
        style={{
          color: "#0061BB",
        }}
      >
        CIBERSORT/x, the core technology of iSort&trade;, is patented
        and exclusively licensed to CiberMed for iSort&trade;.
      </h6>
      <hr style={{ margin: "24px 0" }} />

      <div>
        {data.technologies.map((item, index) => (
          <ReferenceCard item={item} index={index} />
        ))}
      </div>

      

      {/* Applications Section */}
      <p className="custom-title" style={{ margin: "34px 0" }}>
        iSort&trade; Applications
      </p>
      <div>
        {data.applications.map((item, index) => (
          <ReferenceCard item={item} index={index} />
        ))}
      </div>
      <p>
        See{" "}
        <a
          href="https://www.cibermed.com/references"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#0061BB" }}
        >
          more references
        </a>
      </p>
    </>
  );
}
export default function References() {
  return (
    <>
      <WrapperContainer
        title="References"
        content={<ReferencesContent />}
        loggedin={true}
      />
    </>
  );
}
